import { ISigningValuesInterface } from '@app/certificates/signing/signing';

//TODO - currently not used - delete?
export const signingValues: ISigningValuesInterface = {
    signFile: '',
    signFormat: [
        { name: 'PAdES', value: 'PAdES' },
        { name: 'CAdES', value: 'CAdES' },
        { name: 'XAdES', value: 'XAdES' }
    ],
    signLevel: [
        { name: 'BASELINE_LTA', value: 'BASELINE_LTA' },
        { name: 'BASELINE_B', value: 'BASELINE_B' },
        { name: 'BASELINE_T', value: 'BASELINE_T' },
        { name: 'BASELINE_LT', value: 'BASELINE_LT' }
    ],
    signType: [
        { name: 'ENVELOPED', value: 'ENVELOPED' },
        { name: 'ENVELOPING', value: 'ENVELOPING' },
        { name: 'DETACHED', value: 'DETACHED' }
    ],
    signHashAlg: [
        { name: 'SHA256', value: 'SHA256' },
        { name: 'SHA512', value: 'SHA512' }
    ],
    defaults: {
        signFormat: 'CAdES',
        signLevel: 'BASELINE_LTA',
        signType: 'ENVELOPING',
        signHashAlg: 'SHA256'
    }
};

//PAdES should not be shown for documents other than PDF, same for XAdES and XML
export const cadesValues: ISigningValuesInterface = {
    signFile: '',
    signFormat: [
        { name: 'CAdES', value: 'CAdES' }
    ],
    signLevel: [
        { name: 'BASELINE_LTA', value: 'BASELINE_LTA' },
        { name: 'BASELINE_B', value: 'BASELINE_B' },
        { name: 'BASELINE_T', value: 'BASELINE_T' },
        { name: 'BASELINE_LT', value: 'BASELINE_LT' }
    ],
    signType: [
        { name: 'ENVELOPING', value: 'ENVELOPING' },
        { name: 'DETACHED', value: 'DETACHED' }
    ],
    signHashAlg: [
        { name: 'SHA256', value: 'SHA256' },
        { name: 'SHA512', value: 'SHA512' }
    ],
    defaults: {
        signFormat: 'CAdES',
        signLevel: 'BASELINE_LTA',
        signType: 'ENVELOPING',
        signHashAlg: 'SHA256'
    }
};

export const pdfValues: ISigningValuesInterface = {
    signFile: '',
    signFormat: [
        { name: 'PAdES', value: 'PAdES' },
        { name: 'CAdES', value: 'CAdES' }
    ],
    signLevel: [
        { name: 'BASELINE_LTA', value: 'BASELINE_LTA' },
        { name: 'BASELINE_B', value: 'BASELINE_B' },
        { name: 'BASELINE_T', value: 'BASELINE_T' },
        { name: 'BASELINE_LT', value: 'BASELINE_LT' }
    ],
    signType: [
        { name: 'ENVELOPED', value: 'ENVELOPED' },
    ],
    signHashAlg: [
        { name: 'SHA256', value: 'SHA256' },
        { name: 'SHA512', value: 'SHA512' }
    ],
    defaults: {
        signFormat: 'PAdES',
        signLevel: 'BASELINE_LTA',
        signType: 'ENVELOPED',
        signHashAlg: 'SHA256'
    }
};

export const xmlValues: ISigningValuesInterface = {
    signFile: '',
    signFormat: [
        { name: 'XAdES', value: 'XAdES' },
        { name: 'CAdES', value: 'CAdES' }
    ],
    signLevel: [
        { name: 'BASELINE_LTA', value: 'BASELINE_LTA' },
        { name: 'BASELINE_B', value: 'BASELINE_B' },
        { name: 'BASELINE_T', value: 'BASELINE_T' },
        { name: 'BASELINE_LT', value: 'BASELINE_LT' }
    ],
    signType: [
        { name: 'ENVELOPED', value: 'ENVELOPED' },
        { name: 'ENVELOPING', value: 'ENVELOPING' },
        { name: 'DETACHED', value: 'DETACHED' }
    ],
    signHashAlg: [
        { name: 'SHA256', value: 'SHA256' },
        { name: 'SHA512', value: 'SHA512' }
    ],
    defaults: {
        signFormat: 'XAdES',
        signLevel: 'BASELINE_LTA',
        signType: 'ENVELOPED',
        signHashAlg: 'SHA256'
    }
};
